import { useCallback, useDeferredValue, useMemo, useState } from 'react';
import { canEditVisually } from '../utils/visualEditorSupport';

export type BodyEditorMode = 'visual' | 'html';

export function useBodyEditorMode(bodyHtml: string) {
  const [mode, setMode] = useState<BodyEditorMode>(() => (canEditVisually(bodyHtml) ? 'visual' : 'html'));
  const deferredBody = useDeferredValue(bodyHtml);
  const visualSupported = useMemo(() => mode === 'visual' || canEditVisually(deferredBody), [mode, deferredBody]);

  const showVisual = useCallback(() => {
    if (canEditVisually(bodyHtml)) setMode('visual');
  }, [bodyHtml]);
  const showHtml = useCallback(() => setMode('html'), []);

  return { mode, visualSupported, showVisual, showHtml };
}
